import { render } from "./Unauthorizederror.vue?vue&type=template&id=642845e2"
import script from "./Unauthorizederror.vue?vue&type=script&lang=js"
export * from "./Unauthorizederror.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__